import { logEvent } from "@api/session";
import { RRQueryClientProvider } from "@components/RRQueryClientProvider";
import links from "@links";
import { createSignal, Match, onMount, Switch } from "solid-js";
import EventArea from "./EventArea";

export const EventAreaContainer = (props: {
  type: "upcoming" | "results";
  shouldBePrivate?: boolean;
}) => {
  const [isPrivate, setIsPrivate] = createSignal(
    props.shouldBePrivate || false
  );

  onMount(() => {
    logEvent({ eventType: "view" });
  });

  return (
    <RRQueryClientProvider>
      <Switch>
        <Match when={props.type == "upcoming"}>
          <div class="tabs tabs-boxed justify-center">
            <a
              class="tab"
              classList={{ "tab-active": !props.shouldBePrivate }}
              href={links.events}
            >
              Live Events
            </a>
            <a class="tab" href={links.pastEvents}>
              Rally On Demand
            </a>
            <a
              class="tab"
              classList={{ "tab-active": props.shouldBePrivate }}
              href={links.privateEvents}
            >
              Private Events
            </a>
          </div>
        </Match>
        <Match when={props.type == "results"}>
          <div class="tabs tabs-boxed justify-center">
            <button
              class="tab"
              classList={{ "tab-active": !isPrivate() }}
              onClick={() => {
                setIsPrivate(false);
              }}
            >
              Past Public Events
            </button>
            <button
              class="tab"
              classList={{ "tab-active": isPrivate() }}
              onClick={() => {
                setIsPrivate(true);
              }}
            >
              Past Private Events
            </button>
          </div>
        </Match>
      </Switch>
      <EventArea type={props.type} shouldBePrivate={isPrivate()} />
    </RRQueryClientProvider>
  );
};
